import { BrowserSearchEngine } from './common'

const defaultFieldSpecifiers = []

const defaultSyntaxGuideUrl = ''

class Plos extends BrowserSearchEngine {
  constructor (fieldSpecifiers) {
    super('Public Library of Science')
    this.fieldSpecifiers = fieldSpecifiers || defaultFieldSpecifiers
    this.syntaxGuideUrl = defaultSyntaxGuideUrl
  }

  formulateQuery (query) {
    return 'https://journals.plos.org/plosone/search?unformattedQuery=' + query
  }

  lintQuery (queryGraphData) {
    const m = this.lintFieldSpecifiers(queryGraphData, this.fieldSpecifiers)
    return m ? [m] : []
  }

  getSuggestTermsMetaData () {
    return this.getSuggestTermsDbpediaSettings()
  }
}

export default Plos



// WEBPACK FOOTER //
// ./src/formulate_queries/PlosEngine.js